export enum TabModeEnum {
  LIST = "list",
  TABLE = "table"
}

export type TabMode = TabModeEnum.LIST | TabModeEnum.TABLE;
